// src/components/HowItWorks/HowItWorks.jsx
import React from 'react';
import './css/HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Установите агента',
      description: 'Установите нашего агента на устройства для полного контроля и защиты.'
    },
    {
      number: '02',
      title: 'Агенты в одном разделе',
      description: 'Контролируйте статус агента в реальном времени и получайте полную аналитику его работы.'
    },
    {
      number: '03',
      title: 'Автоматическое сканирование',
      description: 'Агенты самостоятельно находят и сканируют все файлы в корпоративной сети без вашего участия.'
    },
    {
      number: '04',
      title: 'AI определяет персональные данные',
      description: 'Искусственный интеллект мгновенно классифицирует документы и выделяет ПДн, паспортные данные, СНИЛС, дипломы и др.'
    },
    {
      number: '05',
      title: 'Отчёт и рекомендации',
      description: 'Получайте готовый отчёт с картой рисков и автоматическими рекомендациями по устранению утечек.'
    },
    {
      number: '06',
      title: 'Защита и мониторинг 24/7',
      description: 'Система продолжает работать в фоновом режиме, предотвращая новые утечки.'
    }
  ];

  return (
    <section className="how-it-works" id = "how-it-works">
      <div className="container how-it-works-container">
        {/* Заголовок + подзаголовок */}
        <div className="h2-background">
          <h2 className="how-it-works-title">Как это работает?</h2>
   
        </div>

        {/* Сетка шагов */}
        <div className="how-it-works-grid">
          {steps.map((step) => (
            <div key={step.number} className="step-card">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;